module.exports = __webpack_public_path__ + "img/twism.e96a8dd2.png";